module.exports = __webpack_public_path__ + "img/hopways-03.93a5bccf.jpg";